"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function NutanixGreyMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M16 12.856a.566.566 0 01-.572.568H12a.594.594 0 01-.384-.144l-2.292-2.064-.04-.04a.574.574 0 01.04-.808l1.716-1.544a.545.545 0 01.4-.144.576.576 0 01.364.144l4.008 3.604c.12.108.188.264.188.428zM15.812 2.996L11.804 6.6a.57.57 0 01-.764 0L9.324 5.056c-.012-.012-.028-.028-.04-.044a.57.57 0 01.04-.804l2.292-2.064A.594.594 0 0112 2h3.428a.574.574 0 01.384.996zM10.096 8.136L4.384 13.28a.586.586 0 01-.384.144H.572a.574.574 0 01-.384-.996l5.244-4.716L.188 2.996A.575.575 0 010 2.568C0 2.252.256 2 .572 2H4c.14 0 .28.052.384.144l5.712 5.144a.566.566 0 010 .848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M15.812 2.996L11.804 6.6a.57.57 0 01-.764 0l-.772-.696L14.644 2h.784a.574.574 0 01.384.996zM10.096 8.136L4.384 13.28a.586.586 0 01-.384.144H1.836l7.572-6.756.688.62a.566.566 0 010 .848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M9.408 6.668l-7.572 6.756H.572a.574.574 0 01-.384-.996l5.244-4.716L.188 2.996A.575.575 0 010 2.568C0 2.252.256 2 .572 2H4c.14 0 .28.052.384.144l5.024 4.524zM14.644 2l-4.376 3.904-.944-.848c-.012-.012-.028-.028-.04-.044a.57.57 0 01.04-.804l2.292-2.064A.594.594 0 0112 2h2.644z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.42 9.556l3.412 3.068H12.08l-2.036-1.832 1.376-1.236zm-.008-.876a.563.563 0 00-.372.144l-1.716 1.544a.574.574 0 000 .848l2.292 2.064a.594.594 0 00.384.144h3.436a.567.567 0 00.564-.568.575.575 0 00-.188-.428l-4.008-3.604a.576.576 0 00-.364-.144h-.028zM14.832 2.8L11.42 5.868l-1.372-1.236L12.084 2.8h2.748zm.596-.8H12a.594.594 0 00-.384.144L9.324 4.208a.57.57 0 00-.04.804.438.438 0 00.04.044L11.04 6.6a.565.565 0 00.764 0l4.008-3.604A.574.574 0 0015.428 2zM3.916 2.8l5.456 4.912-5.456 4.912H1.168l4.8-4.316.66-.596-.66-.596-4.8-4.316h2.748zM4 2H.572A.568.568 0 000 2.568c0 .164.068.32.188.428l5.244 4.716-5.244 4.716a.574.574 0 00.384.996H4c.14 0 .28-.052.384-.144l5.712-5.144a.566.566 0 000-.848L4.384 2.144A.586.586 0 004 2z"
  }));
}

NutanixGreyMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
NutanixGreyMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = NutanixGreyMultitoneFilled;
exports["default"] = _default;